import {
  assertNotEmpty,
  type ConfigurableServer,
  notEmpty,
  type Optional,
} from '@festina-life/core'
import { useQuery } from '@tanstack/react-query'

import { ServerServices } from '../openApiServices'
import { fetchServerTenantsKey } from './keys'

type Props = {
  enabled: boolean
  server: Optional<ConfigurableServer>
}

export const useFetchStandardComponentTenants = ({ enabled, server }: Props) =>
  // Given that fetching tenants from the configuration component is done without suspense, we also want to fetch standard component tenants without suspense
  // in order to have API parity.
  useQuery({
    enabled: enabled && !!server,
    queryKey: server ? fetchServerTenantsKey(server) : [],
    queryFn: async () => {
      assertNotEmpty(server)

      const service = ServerServices[server]

      return await service.api.ConfigurationTenantsService.tenantsServiceGetGetRegisteredTenants(
        {},
      )
    },
    select: (response) => response?.registeredTenants?.filter(notEmpty) ?? [],
  })
